export interface LicenseRecord {
  icp: string[];
  security: string[];
  algorithm: string[];
}

export const useLicense = () => useState<Record<string, LicenseRecord>>('license', () => ({}));
